module.exports = __webpack_public_path__ + "static/media/crew-w-6.0d003586.png";